import styled from 'styled-components';

import { LitButton } from '../../shared/LitButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px 56px;
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin-bottom: 24px;
  background: ${({ variant }) =>
    variant === 'error' ? 'rgba(224, 92, 92, 0.1)' : 'rgba(39, 170, 225, 0.1)'};
  color: ${({ variant }) => (variant === 'error' ? '#e05c5c' : '#27aae1')};
`;

export const Title = styled.h4`
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: bold;
  color: #3c3c3c;
`;

export const Description = styled.p`
  margin: 0;
  max-width: 420px;
  font-size: 14px;
  line-height: 1.5;
  color: #7b7b7b;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: 28px;

  /* margem em vez de gap: o browserslist do projeto ainda inclui ie >= 10 */
  > * + * {
    margin-left: 12px;
  }
`;

export const ActionButton = styled(LitButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;

  svg {
    margin-right: 8px;
  }
`;
